import axiosInstance from "../../axiosInstance";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
export const getStudentPodcast = createAsyncThunk(
  "get/studentPodcast",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/userPodcastList", {
        params: payload,
      });
      return response.data;
    } catch (error) {
      console.log({ error });
      rejectWithValue(error.response.data);
    }
  }
);
const studentPodcast = createSlice({
  name: "studentPodcast",
  initialState: {
    podcast: [],
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(getStudentPodcast.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getStudentPodcast.fulfilled, (state, action) => {
      state.loading = false;
      state.podcast = action.payload;
    });
    builder.addCase(getStudentPodcast.rejected, (state) => {
      state.loading = false;
    });
  },
});

export default studentPodcast.reducer;
